import React, { createContext, useContext, useEffect } from "react";
import useOnboarding from "../hooks/useOnboarding";

const OnboardingContext = createContext();

export const OnboardingProvider = ({ children }) => {
  const onboardingHook = useOnboarding();

  return (
    <OnboardingContext.Provider value={onboardingHook}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error(
      "useOnboardingContext debe usarse dentro de OnboardingProvider"
    );
  }
  return context;
};
